
import React, { memo } from 'react';
import SectionHeading from '../ui/SectionHeading';
import TextParagraph from '../ui/TextParagraph';

interface IntroductionSectionProps {
  content: string;
  index: number;
}

const IntroductionSection: React.FC<IntroductionSectionProps> = ({ content, index }) => {
  // Extract the text content without the duplicate heading
  let displayContent = content;
  
  // Only extract the heading title once
  const title = content.includes('introduction') || content.includes('Introduction') ? 
    'Introduction & Methodology' : content;
  
  // If the content contains duplicate Introduction & Methodology text, remove it
  if (displayContent.includes('Introduction & Methodology')) {
    // Split by lines and remove any line that's only "Introduction & Methodology"
    const lines = displayContent.split('\n');
    displayContent = lines
      .filter(line => line.trim() !== 'Introduction & Methodology')
      .join('\n');
  }
    
  return (
    <div key={index} className="my-4">
      <SectionHeading 
        text={title}
        level="h2"
        className="text-white pb-2 border-b border-gray-800 mb-2"
      />
      <TextParagraph 
        text={displayContent}
        className="mt-2 text-base font-normal" 
      />
    </div>
  );
};

export default memo(IntroductionSection);
